import { render, staticRenderFns } from "./editUserType.vue?vue&type=template&id=352bf7fa"
import script from "./editUserType.vue?vue&type=script&lang=js"
export * from "./editUserType.vue?vue&type=script&lang=js"
import style0 from "./editUserType.vue?vue&type=style&index=0&id=352bf7fa&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports